// Note: This is necessary in order to avoid to load ~100kb in modern browsers
// and creates a separated chunk for the polyfills
async function polyfillsLoader() {
  if (!Object.groupBy || !Set.prototype.difference) {
    await import('./polyfills.js').catch(console.error); // eslint-disable-line no-console
  }
}

await polyfillsLoader();

export {};
